// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TFyK","tabsBox":"styles_tabsBox__3ycDm","createButton":"styles_createButton__3Gery"};